<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    style="    z-index: 50000;"
  >
    <!--
    Background overlay, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
    Modal panel, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      To: "opacity-100 translate-y-0 sm:scale-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100 translate-y-0 sm:scale-100"
      To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
        <button
          type="button"
          class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          @click="close"
        >
          <span class="sr-only">Close</span>
          <svg
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-left sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Customer Information
          </h3>
          <div class="mt-2"></div>
        </div>
      </div>
      <div class="sm:ml-4 mt-4">
        <div v-if="isLoading" class="text-left mt-2 text-sm">
          Loading....
        </div>
        <div v-if="!isLoading && customer && Object.keys(customer).length > 0">
          <div class="flex  mt-4" v-if="customer">
            <div class="flex flex-col">
              <h3
                class="text-xs font-inter leading-normal text-left font-medium text-cool-gray-600 uppercase"
              >
                lifetime value
              </h3>
              <span
                class="font-inter text-left font-medium text-cool-gray-500 uppercase my-4"
              >
                {{ customer.lifetimeVal }}</span
              >
            </div>
            <div class="flex flex-col ml-4">
              <h3
                class="text-xs font-inter leading-normal text-left font-medium text-cool-gray-600 uppercase"
              >
                Customer since
              </h3>
              <span
                class="font-inter text-left font-medium text-cool-gray-500 my-4"
                >{{ customer.createdAt }}</span
              >
            </div>
          </div>

          <div class="mt-4  " v-if="customer.defaultAddress">
            <h2
              class="text-xs font-inter leading-normal text-left font-medium text-cool-gray-600 uppercase"
            >
              default address
            </h2>
            <p
              class="text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
            >
              {{ customer.defaultAddress.first_name }}
              {{ customer.defaultAddress.last_name }}
              <br />
              {{ customer.defaultAddress.address1 }}
              <br />
              {{ customer.defaultAddress.address2 }}
              <br />
              {{ customer.defaultAddress.zip }}
              {{ customer.defaultAddress.city }}
              {{ customer.defaultAddress.province }}
              <br />
              {{ customer.defaultAddress.country_name }}
              <br />
            </p>
          </div>

          <div class="" v-if="customer && Object.keys(customer).length > 0">
            <h2
              class="text-xs font-inter leading-normal text-left font-medium text-cool-gray-600 uppercase py-4"
            >
              Recent orders
            </h2>
            <div class="overflow-hidden rounded px-2">
              <table class="min-w-full ">
                <thead class="bg-white-two ">
                  <tr>
                    <th
                      class="text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2 text-left"
                    >
                      Order Id
                    </th>
                    <th
                      class="text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2 text-left"
                    >
                      Created at
                    </th>
                    <th
                      class="text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2 text-left"
                    >
                      status
                    </th>
                    <th
                      class="text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2 text-left"
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody class="text-cool-gray-500">
                  <tr v-for="(order, index) in orders" :key="index">
                    <td
                      class="text-left text-xs py-2 px-2  font-inter leading-normal "
                    >
                      <a
                        class="text-blue-500"
                        :href="order.url"
                        target="_blank"
                        >{{ order.num }}</a
                      >
                    </td>
                    <td
                      class="text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                    >
                      {{ order.date }}
                    </td>
                    <td
                      class="text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                    >
                      {{ order.status }}
                    </td>
                    <td
                      class="text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                    >
                      {{ order.amount }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-4 ">
            <h6
              class="text-xs font-inter leading-normal text-left font-medium text-cool-gray-600 uppercase"
            >
              Tags
            </h6>
            <span v-if="customer.tags.length === 0">No tags</span>
            <div
              class="text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
            >
              {{ customer.tags }}
            </div>
          </div>

          <div class="mt-4 ">
            <h6
              class="text-xs font-inter leading-normal text-left font-medium text-cool-gray-600 uppercase"
            >
              Note
            </h6>
            <span v-if="!customer.note">No Note</span>
            <div
              class="text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
            >
              {{ customer.note }}
            </div>
          </div>
        </div>
        <div
          class="text-left mt-2 text-sm"
          v-if="!isLoading && customer && Object.keys(customer).length === 0"
        >
          Customer not found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Profile",
  props: {
    phoneNumber: {
      type: String,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      customerInfo: {},
      customer: {},
      orders: [],
      isLoading: false
    };
  },
  created() {
    // Add event listener for escape key
    document.addEventListener("keydown", this.handleEscapeKey);

    this.isLoading = true;
    this.$store
      .dispatch("getCustomerInfo", { phoneNumber: this.phoneNumber })
      .then(response => {
        this.isLoading = false;
        this.customer = response.result.customer;
        this.orders = response.result.orders;
      });
  },
  destroyed() {
    // Remove event listener when component is destroyed
    document.removeEventListener("keydown", this.handleEscapeKey);
  },
  methods: {
    handleEscapeKey(event) {
      if (event.key === "Escape") {
        this.close();
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
